
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// import styles
// import './salescar.scss'
import '../constraints.scss'

// import components
// import HelpText from '../../../../shared/components/HelpText'
import Portal from '../../../../shared/components/Portal'
import Confirm from '../../../../shared/components/Confirm'

// Elements
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import Text from '../../../../shared/elements/text'
import Radio from '../../../../shared/elements/radio'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Button from '../../../../shared/elements/button'
import DropDown from '../../../../shared/elements/dropDown'
import Label from '../../../../shared/elements/label'
import Switch from '../../../../shared/elements/switch'
import Inline from '../../../../shared/elements/inline'
import Textarea from '../../../../shared/elements/textarea'
import AddButton from '../../../../shared/elements/addButton'
import RemoveButton from '../../../../shared/elements/removeButton'
import Grid from '../../../../shared/elements/grid'

// Actions
import { createSaveAgreementConstraint, getAgreementConstraint } from '../../../../actions/agreementConstraint'
import { getCustomerGroups } from '../../../../actions/customerGroup'
import { getBrands } from '../../../../actions/common'

// Utils
import { hasAccess } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      confirmDelete: {
        open: false
      },
      confirmDeactivate: {
        open: false
      },
      constraint: {
        AgreementConstraintId: 0,
        CustomerGroupId: -1,
        CustomerGroupName: '',
        WorkProvider: {
          WorkProviderId: this.props.partnerID
        },
        Name: 'New',
        Active: false,
        Comment: '',
        PriceType: 1,
        ConstraintBrands: [],
        BrandSelectionType: 0,
        HasAgreement: false,
        SelectedBrandNameId: 0
      }
    }
    this.onInputChange = this.onChange.bind(this)
    this.changeType = this.changeType.bind(this)
    this.saveAddConstraint = this.saveAddConstraint.bind(this)
    this.addConstraint = this.addConstraint.bind(this)
    this.getCustomerGroups = this.getCustomerGroups.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.addItem = this.addItem.bind(this)
  }

  componentDidMount () {
    this.getAgreementConstraint(this.props)
    this.getCustomerGroups()
    this.props.getBrands()
  }

  componentWillUpdate (nextProps) {
    if (nextProps.brands === null || nextProps.brands.length === 0) {
      this.props.getBrands()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.AgreementConstraintId !== nextProps.item.AgreementConstraintId) {
      this.getAgreementConstraint(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    let name = e.target.name

    if (e.target.name === 'Active') {
      value = e.target.checked
    }

    if (value === false && name === 'Active' && this.state.constraint.HasAgreement) return
    if (e.target.name === 'BrandSelectionType' || e.target.name === 'SelectedBrandNameId') {
      value = parseInt(e.target.value)
    }
    this.setState({
      // type: 'edit',
      constraint: {
        ...this.state.constraint,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.name !== 'SelectedBrandNameId' && (e.target.type === 'radio' || e.target.type === 'checkbox' || e.target.type === 'select-one')) {
        this.onBlur(e)
      }
    })
  }
  changeType (e) {
    let value = parseInt(e.target.value)
    this.setState({
      constraint: {
        ...this.state.constraint,
        [e.target.name]: value
      }
    })
  }

  onBlur (e) {
    console.log('onBlur')
    if (this.state.constraint.AgreementConstraintId !== 0) {
      this.setState({ type: 'edit' }, () => {
        this.saveAddConstraint()
      })
    }
  }

  getCustomerGroups () {
    this.props.getCustomerGroups()
  }

  getAgreementConstraint (props) {
    if (typeof props.item.AgreementConstraintId !== 'undefined') {
      props.getAgreementConstraint(props.item.AgreementConstraintId).then((res) => {
        let constraint = res.data
        this.setState({
          type: 'edit',
          constraint: constraint
        })
      }, () => {
        this.props.onError()
      })
    } else {
      this.resetCreate()
    }
  }
  saveAddConstraint () {
    console.log('saveAddConstraint')
    if (Number(this.state.constraint.CustomerGroupId) === -1 || isEqual(this.state.constraint.name, '')) return undefined
    this.props.createSaveAgreementConstraint(this.state.constraint).then((res) => {
      this.props.onSave(res.data, this.state.type)
      this.setState({
        constraint: res.data
      }, () => {
        this.props.getAgreementConstraints()
      })
    }, (err) => {
      // Toastr
      // console.log('err', err.response.data.Errors)
      this.setState({
        constraint: err.response.data
      })
      if (err.response.data.Error !== undefined && err.response.data.Error !== null) {
        let error = err.response.data.Error
        if (error === '1' || error === 1) {
          error = '13555'
          let collidedWPName = err.response.data.CollidedWPName
          let collidedConstraintName = err.response.data.CollidedConstraintName
          let text = translation('13557')
          text = text.replace('{0}', collidedWPName).replace('{1}', collidedConstraintName)
          window.toastr.error(text, translation('216'))
        } else if (error === '2' || error === 2) {
          let collidedConstraintName = err.response.data.CollidedConstraintName
          let text = translation('@ Kan ikke aktivere adgang, Koncern {1} er inaktiv')
          text = text.replace('{1}', collidedConstraintName)
          window.toastr.error(text, translation('216'))
        } else {
          window.toastr.error(translation(error), translation('216'))
        }
      } else {
        window.toastr.error(translation('12285'), translation('216'))
      }
    })
  }

  resetCreate () {
    this.setState({
      type: 'create',
      constraint: {
        AgreementConstraintId: 0,
        CustomerGroupId: -1,
        CustomerGroupName: '',
        WorkProvider: {
          WorkProviderId: this.props.partnerID
        },
        Name: 'New',
        Active: false,
        Comment: '',
        PriceType: 1,
        ConstraintBrands: [],
        BrandSelectionType: 0,
        SelectedBrandNameId: 0
      }
      // }, () => {
      //   console.log('reset state', this.state)
    })
  }
  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }
  renderName () {
    let { constraint } = this.state
    if (constraint === null) return null
    return (
      <Text name='Name' value={constraint.Name || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('30')} />
    )
  }
  renderComment () {
    let { constraint } = this.state
    if (constraint === null) return null
    return (
      <LabelWrapper labelText={translation('149')}>
        <Textarea name='Comment' value={constraint.Comment || ''} onChange={this.onChange} onBlur={this.onBlur} />
      </LabelWrapper>
    )
  }
  renderOrderType () {
    let { constraint } = this.state
    if (constraint === null) return null

    return (
      <DropDown name='PriceType' disabled={this.state.type === 'edit'} onChange={this.onChange} value={constraint.PriceType} labelText={translation('69')} >
        <option value={1}>{translation('71')}</option>
        <option value={2}>{translation('785')}</option>
        <option value={3}>{translation('13361')}</option>
        <option value={5}>{translation('13360')}</option>
        <option value={6}>{translation('301')}</option>
        <option value={8}>{translation('1396')}</option>
        <option value={0}>{translation('73')}</option>
      </DropDown>
    )
  }
  renderActive () {
    let { constraint } = this.state
    if (constraint === null || this.state.type === 'create') return null
    const onDeactivate = (e) => {
      if (!e.target.checked && this.state.constraint.HasAgreement) {
        this.setState({
          confirmDeactivate: {
            open: true
          }
        })
      }
    }
    return (
      <Switch name='Active' onChange={this.onChange} onClick={onDeactivate} checked={constraint.Active} labelText={translation('295')} />
    )
  }
  renderCustomerGroup () {
    let { constraint } = this.state
    let customerGroups = this.props.customergroups
    const renderCustomerGroupsMapped = () => {
      if (customerGroups === null || customerGroups.length <= 0) return []
      return customerGroups.reduce((groups, cust, i) => {
        let isEnabled = cust.WorkProviderId === -1 || cust.WorkProviderId === Number(this.props.partnerID)
        let opt = <option value={cust.CustomerGroupId} disabled={!isEnabled} key={cust.CustomerGroupId}>{cust.Name}</option>
        if (isEnabled && cust.Active) {
          return [...groups, opt]
        }
        return [...groups]
      }, [])
      // customerGroups.map((val, i) => {
      //   let isEnabled = val.WorkProviderId === -1 || val.WorkProviderId === Number(this.props.partnerID)
      //   return (<option value={val.CustomerGroupId} disabled={!isEnabled} key={val.CustomerGroupId}>{val.Name}</option>)
      // })
    }
    return (
      <DropDown name='CustomerGroupId' onChange={this.onChange} disabled={this.state.type === 'edit'} value={constraint.CustomerGroupId} labelText={translation('12282')} >
        <option value='-1'>{translation('12283')}</option>
        {renderCustomerGroupsMapped()}
      </DropDown>
    )
  }
  addItem (e) {
    if (this.state.constraint.SelectedBrandNameId !== 0) {
      this.state.constraint.ConstraintBrands.push({
        BrandNameId: this.state.constraint.SelectedBrandNameId,
        AgreementConstraintId: this.state.constraint.AgreementConstraintId
      })
    }
    this.onBlur()
  }
  renderBrands () {
    let isCustomer = !hasAccess([2], this.props.auth.user.UserType)
    if (hasAccess([6], this.props.auth.user.UserType) || this.state.constraint.AgreementConstraintId === 0) return null
    let { constraint } = this.state
    let isDisabled = this.state.constraint.HasAgreement
    // Render brand
    const renderBrand = (val, key) => {
      // Delete item
      const deleteItem = (e) => {
        let constraint = { ...this.state.constraint }
        constraint.ConstraintBrands[key].IsDeleted = true
        this.onBlur()
      }
      return (
        <Grid key={key} cols={[1, 'min-content']} spacing={1}>
          <Label>{val.BrandName}</Label>
          {!isDisabled && (<RemoveButton name={key} onClick={deleteItem} size='m' />)}
        </Grid>
      )
    }
    return (
      <div>
        <LabelWrapper labelText={translation('13473')} helpText={translation('1953')}>
          <Radio id='brands_all' name='BrandSelectionType' value='0' onChange={this.onChange} checked={constraint.BrandSelectionType === 0} disabled={isCustomer || isDisabled} labelText={translation('381')} />
          <Radio id='brands_selected' name='BrandSelectionType' value='1' onChange={this.onChange} checked={constraint.BrandSelectionType === 1} disabled={isCustomer || isDisabled} labelText={translation('13475')} />
        </LabelWrapper>
        {constraint.BrandSelectionType === 1 && (
          <div className='brands'>
            {constraint.ConstraintBrands.map(renderBrand)}
            {!isDisabled && (<Inline fillChildNum={[0]} block>
              <DropDown value={this.state.constraint.SelectedBrandNameId} onChange={this.onChange} name='SelectedBrandNameId'>
                <option value={0} />
                {this.props.brands.length > 0 && this.props.brands.map((val, key) => {
                  return <option value={val.Id} key={key}>{translation(val.Name)}</option>
                })}
              </DropDown>
              <AddButton onClick={this.addItem} />
            </Inline>)}
          </div>
        )}
      </div>
    )
  }
  renderCustomAgreement () {
    let { constraint } = this.state
    if (constraint === null) return null

    const onDelete = () => {
      this.setState({
        confirmDelete: {
          open: true
        }
      })
    }
    let canDelete = hasAccess([2], this.props.auth.user.UserType) && this.state.type === 'edit' && !this.state.constraint.HasAgreement
    return (
      <Col>
        <Panel title={translation('12284')}>
          {this.renderName()}
          {this.renderOrderType()}
          {this.renderCustomerGroup()}
          {this.renderBrands()}
          {this.renderActive()}
          {this.renderComment()}
          {canDelete && (
            <Button style='alert' onClick={onDelete} labelText={translation('786')} />
          )}
        </Panel>
      </Col>
    )
  }

  addConstraint () {
    if (Number(this.state.constraint.CustomerGroupId) === -1) return Promise.reject('no customergroup selected')
    this.setState({ type: 'create' }, () => {

    })
    return this.props.createSaveAgreementConstraint(this.state.constraint).then((res) => {
      this.props.onSave(res.data, this.state.type)
    }, (err) => {
      // Toastr
      // console.log('err', err.response.data.Errors)
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('12285'), translation('216'))
      }
      // Toastr
      // window.toastr.error(translation('13463'), translation('216'))
    })
  }

  render () {
    const confirmDeactivate = (props) => {
      let ctext = props.t('13556')
      return (
        <div>
          {ctext}
        </div>
      )
    }
    return (
      <div className={'constraints__screen'}>
        <fieldset disabled={this.props.creating}>
          {this.renderCustomAgreement()}
        </fieldset>
        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirmDelete.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
        {this.state.confirmDeactivate.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDeactivate')}>
            <Confirm confirm={this.onConfirmDeactivate.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDeactivate')} higher renderText={confirmDeactivate} />
          </Portal>
        )}
      </div>
    )
  }
  onConfirmDelete () {
    this.onPortalClose('confirmDelete')
    this.setState({
      constraint: {
        ...this.state.constraint,
        IsDeleted: true
      }
    }, () => {
      this.props.createSaveAgreementConstraint(this.state.constraint).then(() => {
        this.props.onShouldUpdate()
      })
    })
  }

  onConfirmDeactivate () {
    this.onPortalClose('confirmDeactivate')
    this.setState({
      constraint: {
        ...this.state.constraint,
        Active: false
      }
    }, () => {
      this.onBlur()
    })
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    brands: state.common.brands,
    customergroups: state.common.customergroups
  }
}

export default connect(mapStateToProps, {
  createSaveAgreementConstraint,
  getAgreementConstraint,
  getBrands,
  getCustomerGroups
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Partners/Constraints/View/index.js